/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionStatusUpdatedByUserUserType
 */
export interface PalAuthSubmissionStatusUpdatedByUserUserType {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    type?: string;
    /**
     * 
     */
    description?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionStatusUpdatedByUserUserType interface.
 */
export function instanceOfPalAuthSubmissionStatusUpdatedByUserUserType(value: object): value is PalAuthSubmissionStatusUpdatedByUserUserType {
    return true;
}

export function PalAuthSubmissionStatusUpdatedByUserUserTypeFromJSON(json: any): PalAuthSubmissionStatusUpdatedByUserUserType {
    return PalAuthSubmissionStatusUpdatedByUserUserTypeFromJSONTyped(json, false);
}

export function PalAuthSubmissionStatusUpdatedByUserUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionStatusUpdatedByUserUserType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'type': json['type'] == null ? undefined : json['type'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function PalAuthSubmissionStatusUpdatedByUserUserTypeToJSON(json: any): PalAuthSubmissionStatusUpdatedByUserUserType {
    return PalAuthSubmissionStatusUpdatedByUserUserTypeToJSONTyped(json, false);
}

export function PalAuthSubmissionStatusUpdatedByUserUserTypeToJSONTyped(value?: PalAuthSubmissionStatusUpdatedByUserUserType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'type': value['type'],
        'description': value['description'],
    };
}

